(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurveResultsDeleteController',YieldCurveResultsDeleteController);

    YieldCurveResultsDeleteController.$inject = ['$uibModalInstance', 'entity', 'YieldCurveResults'];

    function YieldCurveResultsDeleteController($uibModalInstance, entity, YieldCurveResults) {
        var vm = this;

        vm.yieldCurveResults = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            YieldCurveResults.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
